import styled from "@emotion/styled";
import { css } from "@emotion/react";
import Icon from "metabase/components/Icon";
import { color } from "metabase/lib/colors";
export const Root = styled.div`
  ${(props) => !props.noPadding && css`
      margin-left: 2em;
      margin-right: 2em;
    `}

  ${(props) => props.hidden && css`
      display: none;
    `}

  ${(props) => !props.hidden && css`
      margin-bottom: 1.5em;
    `}

  ${(props) => props.disabled && css`
      pointer-events: none;
      opacity: 0.4;
    `}

  input, .AdminSelect {
    transition: border 0.3s;

    &:hover {
      transition: border 0.3s;
      border-color: ${() => color("brand")};
    }
  }
`;
export const Title = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;

  ${(props) => props.variant === "default" && css`
      font-weight: 700;
    `}
`;
export const Description = styled.span`
  margin-bottom: 0.5em;
`;
export const InfoIconContainer = styled.div`
  display: flex;
  margin-left: 0.5em;
`;
export const InfoIcon = styled(Icon)`
  ${(props) => props.variant === "form-field" && css`
      color: ${color("bg-dark")};

      &:hover {
        color: ${color("brand")};
      }
    `}
`;
